const RadioCheckboxUnCheckedSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none">
    <rect
      width={23}
      height={23}
      x={0.5}
      y={1.125}
      fill="#fff"
      stroke="#D4D5D5"
      rx={11.5}
    />
  </svg>
)
export { RadioCheckboxUnCheckedSvg }
